var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.3,10c-0.2-0.9-0.5-1.7-1-2.4l0.9-0.9l-2.8-2.8l-0.9,0.9c-0.7-0.5-1.5-0.8-2.4-1V2.5h-4v1.2C9.1,4,8.3,4.3,7.6,4.8 L6.7,3.9L3.9,6.7l0.9,0.9C4.3,8.3,4,9.1,3.7,10H2.5v4h1.2c0.2,0.9,0.5,1.7,1,2.4l-0.9,0.9l2.8,2.8l0.9-0.9c0.7,0.5,1.5,0.8,2.4,1 v1.2h4v-1.2c0.9-0.2,1.7-0.5,2.4-1l0.9,0.9l2.8-2.8l-0.9-0.9c0.5-0.7,0.8-1.5,1-2.4h1.2v-4H20.3z M12,19.5c-4.1,0-7.5-3.4-7.5-7.5 S7.9,4.5,12,4.5s7.5,3.4,7.5,7.5S16.1,19.5,12,19.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon-settings.f7b9e0796474374516e5a6cbc95ac747.svg";
export { ForwardRef as ReactComponent };